import React from "react"

export const EXPERT_ALEXANDRA_MELNIK = {
  question:
    "Почему «Халва» лучше подходит для повседневных и крупных трат по сравнению с кредитными картами?",
  personName: "Александра Мельник",
  position: "Автор финансового блога",
  text: (
    <>
      <p>
        Карта «Халва» — это продуманная альтернатива обычной кредитке. Она позволяет совершать
        покупки с рассрочкой* до 24 месяцев без процентов, если соблюдаете условия. Это удобно как
        для повседневных расходов (например, в супермаркете), так и для крупных трат — техники,
        ремонта или обучения.
      </p>
      <br />
      <p>
        У каждой покупки свой срок рассрочки*, и вы точно знаете, когда и сколько нужно платить. В
        отличие от классических кредитных карт, у «Халвы» нет запутанного льготного периода — график
        прост и прозрачен. Вы не переплачиваете, если платите вовремя, и не зависите от даты
        выписки. Все устроено так, чтобы было удобно клиенту.
      </p>
    </>
  ),
  avatarUrl: "https://api.halvacard.ru/public-api/files/36bdc8b8-cc75-44a7-9f49-3341176e1ec9.jpeg",
}

export const EXPERT_ILVINA_HAZIEVA = {
  question: "Как «Халва» помогает получать больше бонусов по сравнению с дебетовыми картами?",
  personName: "Ильвина Хазиева",
  position: "Автор финансового блога",
  text: (
    <>
      <p>
        С «Халвой» вы получаете кэшбэк практически за каждую покупку, а с подпиской «Халва.Десятка»
        — особенно выгодно. До 10% возврата на покупки у партнеров, 10% за поездки в «Яндекс.Такси»
        и до 2% даже вне партнерской сети — это заметно выше, чем у большинства дебетовых карт.
      </p>
      <br />
      <p>
        Кэшбэк начисляется в рублях, его можно тратить как угодно. Вы не просто расплачиваетесь — вы
        получаете реальную выгоду от повседневных трат. Особенно если учитываете условия, покупаете
        у партнеров и оформляете подписку — тогда «Халва» становится лидером по бонусам среди
        повседневных карт.
      </p>
    </>
  ),
  avatarUrl: "https://api.halvacard.ru/public-api/files/9db7039f-cef8-481e-b84d-91b1e43468df.jpeg",
}

export const EXPERT_ARTUR_SAFIN = {
  question: "Почему карта «Халва» — более выгодная и гибкая альтернатива займам?",
  personName: "Артур Сафин",
  position: "Автор финансового блога",
  text: (
    <>
      <p>
        Если вы хотите купить что-то сейчас, но не хотите платить проценты — «Халва» дает такую
        возможность. Покупки делятся на равные части, и если вы платите вовремя, переплат не будет.
        В отличие от займов, вам не нужно оформлять отдельный кредит на каждую покупку — все
        делается автоматически при оплате картой.
      </p>
      <br />
      <p>
        Причем лимит можно использовать повторно: погасили часть — снова доступен. Это гибко,
        удобно, а часто и быстрее, чем брать займ. Кроме того, вы можете сразу видеть, сколько
        платите в месяц, планировать свой бюджет — это делает «Халву» разумным финансовым
        инструментом.
      </p>
    </>
  ),
  avatarUrl: "https://api.halvacard.ru/public-api/files/aae9ef4c-8011-44e1-9dbb-507c5262493c.jpeg",
}
